import { GetGuid } from 'components/common/lib';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import css_class from './search.module.css';

export interface IComboBoxData {
    id: string;
    value: string;
}

export interface IPropsComboBox {
    data: IComboBoxData[];
    selected?: string;
    label?: string;
    invalid?: boolean;
    type?: 'search' | 'default';
    width?: string;
    placeholder?: string;
    disabled?: boolean;
    onClick?: (item: IComboBoxData) => void;
    onEnter?: (item: IComboBoxData) => void;
}
export interface IPropsInputComboBox {
    placeholder?: string;
    invalid?: boolean;
    type?: 'search' | 'default';
    width?: string;
    value?: string;
    disabled?: boolean;
    OnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    OnClick: () => void;
    OnKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
export interface IPropsDataComboBox {
    data: IComboBoxData[];
    width?: string;
    value?: string;
    onClick: (item: IComboBoxData) => void;
}

const ComboBox: React.FC<IPropsComboBox> = ({
    data,
    selected,
    placeholder,
    disabled,
    label = '',
    type = 'default',
    width = '160px',
    invalid = false,
    onClick,
    onEnter
}) => {
    const [vis, setVis] = useState<boolean>(false);
    const [valueChang, setValue] = useState<string>('');
    const [EnterOk, setEnterOk] = useState<boolean>(false);
    const [dataView, setDataView] = useState<IComboBoxData[]>(data);
    const containerRef = useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        setDataView(data);
    }, [data]);

    React.useEffect(() => {
        if (onEnter && EnterOk) {
            //console.log(valueChang);
            let _index: number = -1;
            data.forEach((item, ind) => {
                //console.debug(item.value+"=="+valueChang);
                if (item.value === valueChang) _index = ind;
            });
            //console.debug(_index);
            if (_index != -1) onEnter(data[_index]);
            else {
                let _item: IComboBoxData = { id: '', value: valueChang };
                _item.id = '';
                _item.value = valueChang;
                onEnter(_item);
            }
            setEnterOk(false);
        }
    }, [EnterOk]);

    let viewLabel = <div></div>;
    let height = '24px';
    if (label != '') {
        height = '48px';
        viewLabel = (
            <div style={{ width: width }} className={css_class.label}>
                {label}
            </div>
        );
    }

    useEffect(() => {
        if (!disabled) {
            let inputText = valueChang.toLowerCase();
            let newData: IComboBoxData[] = [];
            if (inputText !== '') {
                newData = data.filter((item) => item.value.toLowerCase().indexOf(inputText) >= 0);
            } else {
                newData = data;
            }
            setDataView(newData);
        }
    }, [valueChang]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.currentTarget.value);
        if (!vis) setVis(!vis);
    };

    const ClickWin = () => {
        if (!disabled) setVis(!vis);
    };

    function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
        if (onEnter) {
            if (event.key == 'Enter') {
                setEnterOk(true);
            }
        }
    }

    const handleClick = (item: IComboBoxData) => {
        setVis(false);
        if (onClick) onClick(item);
        setDataView(data);
    };

    function GetValue(): string {
        let defValue: string = '';
        if (selected) {
            data.forEach((item, ind) => {
                if (item.id == selected) {
                    defValue = item.value;
                }
            });
        }
        return defValue;
    }

    useEffect(() => {
        const iframe = document.getElementById('mainframe') as HTMLIFrameElement;

        function CloseDataView(e: any) {
            if (containerRef.current !== null && !containerRef.current.contains(e.target)) {
                setVis(false);
            }
        }

        window.addEventListener('mousedown', CloseDataView);
        if (iframe) {
            const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

            if (iframeDocument) {
                iframeDocument.addEventListener('mousedown', CloseDataView);
            }
        }

        return () => {
            window.removeEventListener('mousedown', CloseDataView);
            if (iframe) {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
                if (iframeDocument) {
                    iframeDocument.removeEventListener('mousedown', CloseDataView);
                }
            }
        };
    }, []);

    return (
        <div ref={containerRef} style={{ height: height, width: width }}>
            {viewLabel}
            <InputView
                OnChange={handleChange}
                OnKeyDown={handleKeyDown}
                placeholder={placeholder}
                invalid={invalid}
                type={type}
                width={width}
                disabled={disabled}
                value={GetValue()}
                OnClick={ClickWin}
            />
            {vis && <DataView data={dataView} onClick={handleClick} width={width} value={selected} />}
        </div>
    );
};

export default ComboBox;

class InputView extends React.Component<IPropsInputComboBox> {
    constructor(props: IPropsInputComboBox) {
        super(props);
    }

    shouldComponentUpdate(nextProps: IPropsInputComboBox) {
        let nextPropsStr: string = JSON.stringify(nextProps);
        let propsStr: string = JSON.stringify(this.props);
        if (nextPropsStr != propsStr) {
            //console.debug("Рендеринг компонент Textarea");
            //this.props.OnChange();
            return true;
        } else {
            //console.debug("Не рендеринг компонент Textarea");
            return false;
        }
    }

    SearchIcon = (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.8819 11.3147L8.12364 7.5605C8.88637 6.65264 9.26915 5.48536 9.19215 4.30212C9.11514 3.11888 8.58428 2.01106 7.71031 1.20972C6.83633 0.408378 5.68673 -0.0246049 4.50126 0.0010808C3.3158 0.0267665 2.18603 0.509137 1.34758 1.34758C0.509137 2.18603 0.0267665 3.3158 0.0010808 4.50126C-0.0246049 5.68673 0.408378 6.83633 1.20972 7.71031C2.01106 8.58428 3.11888 9.11514 4.30212 9.19215C5.48536 9.26915 6.65264 8.88637 7.5605 8.12364L11.3147 11.8819C11.3519 11.9193 11.396 11.949 11.4447 11.9693C11.4934 11.9896 11.5456 12 11.5983 12C11.651 12 11.7032 11.9896 11.7519 11.9693C11.8006 11.949 11.8447 11.9193 11.8819 11.8819C11.9193 11.8447 11.949 11.8006 11.9693 11.7519C11.9896 11.7032 12 11.651 12 11.5983C12 11.5456 11.9896 11.4934 11.9693 11.4447C11.949 11.396 11.9193 11.3519 11.8819 11.3147ZM0.814871 4.60904C0.814871 3.85862 1.03739 3.12506 1.4543 2.50111C1.87121 1.87716 2.46378 1.39086 3.15707 1.10368C3.85037 0.816513 4.61325 0.741376 5.34925 0.887775C6.08524 1.03417 6.7613 1.39553 7.29192 1.92616C7.82255 2.45678 8.18391 3.13284 8.33031 3.86883C8.4767 4.60483 8.40157 5.36771 8.11439 6.06101C7.82722 6.7543 7.34092 7.34687 6.71697 7.76378C6.09302 8.18069 5.35946 8.40321 4.60904 8.40321C3.60309 8.40215 2.63864 8.00207 1.92732 7.29075C1.21601 6.57944 0.815928 5.61499 0.814871 4.60904Z"
                fill="#AEAEAE"
            />
        </svg>
    );

    render() {
        let id = GetGuid();
        let className: string = this.props.type == 'default' ? css_class.def : css_class.search;
        if (this.props.invalid) className += ' ' + css_class.invalid;
        let defValue: string = this.props.value != undefined ? this.props.value : '';
        let left = 'calc(100% - 16px)';
        if (this.props.width && this.props.width.indexOf('%') > -1) left = 'calc(' + this.props.width + ' - 16px)';

        return (
            <div key={id} className={css_class.main} style={{ width: this.props.width }}>
                <input
                    type="text"
                    className={className}
                    placeholder={this.props.placeholder}
                    defaultValue={`${defValue}`}
                    disabled={this.props.disabled}
                    onChange={this.props.OnChange}
                    onKeyDown={this.props.OnKeyDown}
                />
                {this.props.type !== 'search' && (
                    <div
                        style={{ left: left }}
                        className={css_class.svg}
                        onClick={(e) => {
                            this.props.OnClick();
                        }}>
                        <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.137205 0.774744C-0.280154 0.351336 0.345885 -0.283775 0.798024 0.139632L4.4847 3.87973L8.20616 0.139632C8.62352 -0.283775 9.28434 0.351336 8.86698 0.774744L4.8325 4.86768C4.6586 5.0441 4.34558 5.0441 4.1369 4.86768L0.137205 0.774744Z"
                                fill="#AEAEAE"
                            />
                        </svg>
                    </div>
                )}
            </div>
        );
    }
}

const DataView: React.FC<IPropsDataComboBox> = ({ data, width, value, onClick }) => {
    const [startIndex, setStartIndex] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);

    const itemHeight = 24; // Высота одного элемента
    const visibleCount = 15; // Количество видимых элементов

    const actualVisibleCount = Math.min(data.length, visibleCount);

    const handleScroll = () => {
        if (containerRef.current) {
            const scrollTop = containerRef.current.scrollTop;
            const newStartIndex = Math.floor(scrollTop / itemHeight);
            setStartIndex(newStartIndex);
        }
    };

    const visibleData = useMemo(() => {
        return data.slice(startIndex, startIndex + actualVisibleCount);
    }, [startIndex, data, actualVisibleCount]);

    return (
        <div
            ref={containerRef}
            onScroll={handleScroll}
            style={{
                height: itemHeight * actualVisibleCount,
                overflowY: data.length > actualVisibleCount ? 'auto' : 'hidden',
                width: width ? `${width}px` : '300px'
            }}
            className={css_class.windows}>
            <div style={{ height: data.length * itemHeight, position: 'relative' }}>
                {visibleData.map((item, index) => (
                    <div
                        key={item.id}
                        className={`${css_class.data_item} ${value === item.id ? css_class.sel : ''}`}
                        style={{
                            position: 'absolute',
                            top: (startIndex + index) * itemHeight,
                            height: itemHeight,
                            width: '100%'
                        }}
                        title={item.value}
                        onClick={(e) => {
                            onClick(item);
                        }}>
                        <div className={css_class.text}>{item.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
